enum MeasureRepresentationGuids {
    LINE_VOLUME_GUID = "9BB77B7C-78A7-4DA0-AA5B-36B5AEABFA58",
    LINE_IMPRINT_GUID = "cbb53bf8-a51a-4a46-aa12-63bb5f8b53bb",
    POLYLINE_PANEL_GUID = "E573EE24-4CC6-4830-B58A-948CD7E34C4B",
    EXTRUSION_ROOM_GUID = "27C5C4C9-6DCD-459A-A020-7AE7C5B70CE9",
    EXTRUSION_GUID = "A3FAFC9C-6185-4A37-B6B2-95D85BD88BC9",
    LINE_VOLUME_OFFSET_GUID = "d708b188-8a7b-421d-9b46-9ea7a46997ee",
    LINE_VOLUME_DOOR_GUID = "7F505573-43B0-46E5-8656-0DDD8C1DA28A",
    FINE_SURFACE_GUID = "dd3a4fdd-082a-46de-ad6f-b018e74ca519",
    DISK_GUID = "9C9D0D4A-8B22-4333-8D3D-B94D4935F873",
}

export default MeasureRepresentationGuids;
